module.exports = __webpack_public_path__ + "img/ic_sim.d7a8b562.png";